import React from 'react';
import PropTypes from 'prop-types';

export default function Columns({ columns = [] }) {
  return (
    <div className="bipolar-vertical-columns">
      {columns.map((column, index) => {
        let margin = 'bipolar-vertical-column--center';
        if (index === 0) {
          margin = 'bipolar-vertical-column--top';
        }
        if (index === columns.length - 1) {
          margin = 'bipolar-vertical-column--bottom';
        }

        return (
          <div
            key={column}
            className={`bipolar-vertical-column ${margin}`}
            data-column-id={column}
            data-column-order={index}
            role="button"
            tabIndex={0}
          ></div>
        );
      })}
    </div>
  );
}

Columns.propTypes = {
  columns: PropTypes.array,
};
